import { QueryClient } from '@tanstack/react-query'

let queryClientInstance: QueryClient | undefined

export const getQueryClient = (): QueryClient => {
    if (!queryClientInstance) {
        queryClientInstance = new QueryClient({
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                    retry: false,
                },
            },
        })

        queryClientInstance.getQueryCache().subscribe((event) => {
            if (event.type !== 'removed') return
            if (event.query.queryKey[0] !== 'assetThumbnail') return
            const url = event.query.state.data
            if (typeof url === 'string' && url.startsWith('blob:')) {
                URL.revokeObjectURL(url)
            }
        })
    }
    return queryClientInstance
}
